export default __webpack_public_path__ + "static/media/navic-chip.932d2601.jpg";